export function generateSequence(arr: string[]): string {
  function stringToNumber(str: string): number {
    let result = 0;
    for (let i = 0; i < str.length; i++) {
      result = result * 26 + (str.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
    }
    return result;
  }

  function numberToString(num: number): string {
    let result = '';
    while (num > 0) {
      const remainder = (num - 1) % 26;
      result = String.fromCharCode('A'.charCodeAt(0) + remainder) + result;
      num = Math.floor((num - 1) / 26);
    }
    return result;
  }

  if (arr.length === 0) {
    return 'A';
  }

  const numericArray = arr.map(stringToNumber);
  const maxNumericValue = Math.max(...numericArray);
  const nextNumericValue = maxNumericValue + 1;
  const nextString = numberToString(nextNumericValue);
  return nextString;
}

export function sortBySortOrder<T extends { sortOrder?: number }>(array: T[]): T[] {
  return [...array].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}

export function calculateSkipFromPage({ page, limit }: { page: number; limit: number }): number {
  return (page - 1) * limit;
}

export const commonHelpers = {
  generateSequence,
  sortBySortOrder,
  calculateSkipFromPage,
};
